import { z } from 'zod';

const domainPattern = /^[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

export const updateCurrentWorkspaceSchema = z.object({
  name: z.string().min(2, 'Name is required'),
  slug: z
    .string()
    .min(2, 'Slug is required')
    .regex(/^[a-z0-9-]+$/, 'Lowercase, numbers and dashes only'),
  industry_id: z.string().min(1, 'Industry is required'),
  primary_domain: z
    .string()
    .trim()
    .refine(
      (value) => value.length === 0 || domainPattern.test(value),
      'Domain must include a valid extension like .com, .net, .io, etc.',
    ),
  logo_asset_key: z.string(),
});
